import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { ClientPermissionsService } from '@app/features/crm/services/client-permissions.service'
import { CLIENT_TYPE_GROUPS } from '@app/features/crm/constants/client-type.constants'
import { UserStore } from '@core/services/user/user.store'

async function isShikshaUserByClientTypes(): Promise<boolean> {
    const userStore = inject(UserStore)
    const normalizedUserType = userStore.getUserData()?.user_type?.trim().toLowerCase()
    if (normalizedUserType?.includes('shiksha')) {
        return true
    }

    const clientPermissionsService = inject(ClientPermissionsService)
    try {
        const allowedClientTypeIds = await clientPermissionsService.getAllowedClientTypeIds()
        const shikshaTypeIds = CLIENT_TYPE_GROUPS.SHIKSHA_TYPES as readonly number[]
        return allowedClientTypeIds.some((clientTypeId) => shikshaTypeIds.includes(clientTypeId))
    } catch {
        return false
    }
}

export const shikshaHomeGuard: CanActivateFn = async () => {
    const router = inject(Router)
    if (await isShikshaUserByClientTypes()) {
        return router.parseUrl('/shiksha')
    }
    return true
}

export const shikshaHomePageGuard: CanActivateFn = async () => {
    const router = inject(Router)
    if (!(await isShikshaUserByClientTypes())) {
        return router.parseUrl('')
    }
    return true
}
